'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { UpsellRootContext } from './context/upsell-root.context';
import { upsellLegalRecipe } from './styles/upsell-legal.styles';
import type { UpsellLegalPropsInterface } from './types/upsell-legal.types';

/**
 * @since 10.0.0
 */
export const UpsellLegal = forwardRef<HTMLDivElement, UpsellLegalPropsInterface>(
  (props: UpsellLegalPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;
    const { tone } = useContext(UpsellRootContext);
    const styles = css(upsellLegalRecipe.raw({ tone }), cssProp);

    return (
      <div
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Upsell.Legal"
        className={cx('c11n', styles, className)}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

UpsellLegal.displayName = 'Upsell.Legal';
